var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTournamentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1c0 .42-.035.93-.105 1.5H19V3c0 1.255-.259 2.858-1.076 4.165-.785 1.256-2.073 2.212-4.034 2.324-.814 1.66-1.853 2.983-3.099 3.385L11.5 15v2h1a2 2 0 012 2h-9a2 2 0 012-2h1v-2l.709-2.126c-1.246-.402-2.285-1.725-3.1-3.385-1.96-.112-3.248-1.068-4.033-2.324C1.259 5.858 1 4.255 1 3v-.5h3.105A12.66 12.66 0 014 1h12zM4.254 3.5H2.015c.062 1.035.323 2.197.909 3.135.552.883 1.4 1.586 2.715 1.799C4.984 6.823 4.517 5.032 4.254 3.5zM14.36 8.434c.655-1.611 1.122-3.402 1.385-4.934h2.239c-.062 1.035-.323 2.197-.909 3.135-.552.883-1.4 1.586-2.715 1.799z",
    fill: "#9A9CAC"
  })));
}

export default SvgTournamentIcon;